export default "__VITE_ASSET__CFDE9NxP__"